export const STATE_LICENSE_API_NAMES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'D_C',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachussetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New_Hampshire',
  'New_Jersey',
  'New_Mexico',
  'New_York',
  'North_Carolina',
  'North_Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rode_Island',
  'South_Carolina',
  'South_Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West_Virginia',
  'Wisconsin',
  'Wyoming'
];

export const STATE_LABELS = {
  Alabama: 'Alabama',
  Alaska: 'Alaska',
  Arizona: 'Arizona',
  Arkansas: 'Arkansas',
  California: 'California',
  Colorado: 'Colorado',
  Connecticut: 'Connecticut',
  D_C: 'DC',
  Delaware: 'Delaware',
  Florida: 'Florida',
  Georgia: 'Georgia',
  Hawaii: 'Hawaii',
  Idaho: 'Idaho',
  Illinois: 'Illinois',
  Indiana: 'Indiana',
  Iowa: 'Iowa',
  Kansas: 'Kansas',
  Kentucky: 'Kentucky',
  Louisiana: 'Louisiana',
  Maine: 'Maine',
  Maryland: 'Maryland',
  Massachussetts: 'Massachusetts',
  Michigan: 'Michigan',
  Minnesota: 'Minnesota',
  Mississippi: 'Mississippi',
  Missouri: 'Missouri',
  Montana: 'Montana',
  Nebraska: 'Nebraska',
  Nevada: 'Nevada',
  New_Hampshire: 'New Hampshire',
  New_Jersey: 'New Jersey',
  New_Mexico: 'New Mexico',
  New_York: 'New York',
  North_Carolina: 'North Carolina',
  North_Dakota: 'North Dakota',
  Ohio: 'Ohio',
  Oklahoma: 'Oklahoma',
  Oregon: 'Oregon',
  Pennsylvania: 'Pennsylvania',
  Rode_Island: 'Rhode Island',
  South_Carolina: 'South Carolina',
  South_Dakota: 'South Dakota',
  Tennessee: 'Tennessee',
  Texas: 'Texas',
  Utah: 'Utah',
  Vermont: 'Vermont',
  Virginia: 'Virginia',
  Washington: 'Washington',
  West_Virginia: 'West Virginia',
  Wisconsin: 'Wisconsin',
  Wyoming: 'Wyoming'
};

export function getStatesWithActiveLicenseNumber(user) {
  return Object.keys(STATE_LABELS)
    .filter(key => {
      if (key === 'Texas') {
        return user[`${key}_License_Informatio`];
      } else {
        return user[`${key}_License_Number`];
      }
    })
    .map(key => STATE_LABELS[key]);
}
